import React, { forwardRef } from "react";

import { Field, getIn, FieldProps } from "formik";
import { dissoc } from "ramda";

import { Textarea, TextareaProps } from "src/components/Textarea";

export interface FormikTextareaProps extends Omit<TextareaProps, "name"> {
  /** Formik field name. */
  name: string;
}

const FormikTextarea = forwardRef<HTMLTextAreaElement, FormikTextareaProps>(
  ({ name, onChange: onChangeProp, ...rest }, ref) => (
    <Field name={name}>
      {({ field, meta, form }: FieldProps) => {
        const { status = {}, setStatus } = form;
        const fieldStatus = getIn(status, name);

        const fieldProps = {
          ...field,
          onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => {
            setStatus(dissoc(name, status));
            field.onChange(e);
            onChangeProp?.(e);
          },
        };

        return (
          <Textarea
            ref={ref}
            error={meta.touched ? meta.error || fieldStatus : ""}
            {...fieldProps}
            {...rest}
          />
        );
      }}
    </Field>
  )
);

FormikTextarea.displayName = "FormikTextarea";

export { FormikTextarea };
